import axios from 'axios';

import { kickUserOutIfTokenExpired } from 'utils';
import { RAYCHAT_FAQ_API_URL } from 'utils/constants';

const getAxiosInstance = (locale) => {
  let token = localStorage.getItem('token');

  const instance = axios.create({
    baseURL: RAYCHAT_FAQ_API_URL,
    // withCredentials: false,

    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
  });

  kickUserOutIfTokenExpired(instance, locale);

  return instance;
};

export const handleFetchFAQList = async (page, pageSize, channelId, locale) => {
  const res = await getAxiosInstance(locale).get('/faq', {
    params: {
      page,
      pageSize,
      channelId,
    },
  });

  return res.data;
};

export const handleFetchSingleFAQ = async (faqId, locale) => {
  const res = await getAxiosInstance(locale).get(`/faq/${faqId}`);
  return res.data;
};

export const handleAddFAQ = async (data, locale) => {
  const res = await getAxiosInstance(locale).post('/faq', data);
  return res.data;
};
export const handleUpdateFAQ = async (faqId, data, locale) => {
  const res = await getAxiosInstance(locale).put(`/faq/${faqId}`, data);
  return res.data;
};

export const handleFetchQuestions = async (faqId, containerId, locale) => {
  const res = await getAxiosInstance(locale).get('/question', {
    params: {
      faqId,
      containerId,
    },
  });
  return res.data;
};

export const handleAddQuestion = async (data, locale) => {
  const { faqId, ...questionData } = data;
  const res = await getAxiosInstance(locale).post(
    `/faq/${faqId}/question`,
    questionData
  );
  return res.data;
};

export const handleSortQuestions = async (faqId, data, locale) => {
  const res = await getAxiosInstance(locale).post(`/faq/${faqId}/sort`, {
    questions: data,
  });
  return res.data;
};

export const handleUpdateQuestion = async (qId, faqId, data, locale) => {
  const res = await getAxiosInstance(locale).put(
    `faq/${faqId}/question/${qId}`,
    data
  );
  return res.data;
};

export const handleDeleteQuestion = async (qId, faqId, locale) => {
  const res = await getAxiosInstance(locale).delete(
    `faq/${faqId}/question/${qId}`
  );
  return res.data;
};

export const handleDeleteFAQ = async (faqId, locale) => {
  const res = await getAxiosInstance(locale).delete(
    `faq/${faqId}`
  );
  return res.data;
}
